// extracted by mini-css-extract-plugin
export default {"labelWrapper":"LandscapeImageBlockEditTemplate_labelWrapper__OWtj9"};